export enum ABG_NAV {
  ABG_FAQS = 'abg_faqs'
}
